











import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ILinkedPageObjectSpecifiable, ILinkedObjectSpecifiable } from "../../../../domain/format/objects";
import { CommonComponentsContainer } from "../../../../../formatEditor/components/format/editors/contents";
import { FormatObjectSelectorColumnTypes } from "../../../../../formatEditor/components/format/editors/contents/commonComponents/selectors";
import { IFormatObjectEditable } from "../../../../../formatEditor/domain/editableFormat";
import { instanceOfIItemSelectTriggerBehaviorPropertyEditable } from "../../../../../formatEditor/domain/editableFormat/properties";

@Component
export default class ItemSelectTriggerBehaviorEditorFromUserDefined extends Mixins() {
  @Prop()
  linkedObjectIdentifier: ILinkedObjectSpecifiable;

  @Prop()
  commonComponents: CommonComponentsContainer;

  get pageKey(): number {
    return this.commonComponents.currentPage.pageKey().getValue();
  }

  get currentLinkedObjectIdentifier(): ILinkedPageObjectSpecifiable {
    return {
      pageKey: this.pageKey,
      type: this.linkedObjectIdentifier.type,
      id: this.linkedObjectIdentifier.id,
      key: this.linkedObjectIdentifier.key,
      subKey: this.linkedObjectIdentifier.subKey,
      tableIndex: this.linkedObjectIdentifier.tableIndex,
      isDate: this.linkedObjectIdentifier.isDate,
    };
  }

  get targets(): ILinkedPageObjectSpecifiable[] {
    return Enumerable.from(this.commonComponents.allPagesFormatObjectsForEachPage)
      .selectMany(p => Enumerable.from(p.objects)
        .selectMany(o => this.duplicateTargets(o, p.pageKey))
        .toArray())
      .toArray();
  }

  private duplicateTargets(object: IFormatObjectEditable, pageKey: number): ILinkedPageObjectSpecifiable[] {
    if (!instanceOfIItemSelectTriggerBehaviorPropertyEditable(object) || !object.itemSelectTriggerBehavior().isEditable()) {
      return [];
    }
    return Enumerable.from(object.itemSelectTriggerBehavior().getValue().targets)
      .where(t => this.compareLinkedPageObjectSpecifiable(t, this.currentLinkedObjectIdentifier))
      .select(t => this.toLinkedPageObjectSpecifiable(object, pageKey))
      .toArray();
  }

  private compareLinkedPageObjectSpecifiable(a: ILinkedPageObjectSpecifiable, b: ILinkedPageObjectSpecifiable): boolean {
    return a.pageKey === b.pageKey &&
      a.type === b.type &&
      a.id === b.id &&
      a.key === b.key &&
      a.subKey === b.subKey &&
      (a.tableIndex ? a.tableIndex.row : null) === (b.tableIndex ? b.tableIndex.row : null) &&
      (a.tableIndex ? a.tableIndex.column : null) === (b.tableIndex ? b.tableIndex.column : null) &&
      a.isDate === b.isDate;
  }

  get selectionObjects(): ILinkedPageObjectSpecifiable[] {
    return Enumerable.from(this.commonComponents.allPagesFormatObjectsForEachPage)
      .selectMany(p => Enumerable.from(p.objects)
        .where(o => this.conditionsOfEachElementType(o))
        .select(o => this.toLinkedPageObjectSpecifiable(o, p.pageKey))
        .toArray())
      .toArray();
  }

  private conditionsOfEachElementType(object: IFormatObjectEditable): boolean {
    if (!instanceOfIItemSelectTriggerBehaviorPropertyEditable(object) || !object.itemSelectTriggerBehavior().isEditable()) {
      return false;
    }
    const linkedObject = object.toLinkedObjectIdentifier();
    return !!linkedObject.id && !!linkedObject.key && linkedObject.key !== "";
  }

  private toLinkedPageObjectSpecifiable(object: IFormatObjectEditable, pageKey: number): ILinkedPageObjectSpecifiable {
    const linkedObject = object.toLinkedObjectIdentifier();
    return {
      pageKey: pageKey,
      type: linkedObject.type,
      id: linkedObject.id,
      key: linkedObject.key,
      subKey: linkedObject.subKey,
      tableIndex: linkedObject.tableIndex,
      isDate: linkedObject.isDate,
    };
  }

  async showItemSelectTriggerEditDialog() {
    const dialog = this.commonComponents.getDialogs().getFormatObjectSelectDialog();
    const targets = await dialog.show(
      this.targets,
      this.selectionObjects,
      ["selection", "key", "id", "pageNumber"],
      ["selection", "key", "id", "pageNumber"],
      true,
      false,
      [],
      this.toCellString);
    if (!targets) { return; }
    this.updateTargets(targets);
  }

  private toCellString(column: FormatObjectSelectorColumnTypes, row: ILinkedPageObjectSpecifiable): string {
    switch (column) {
      case "id":
        return row.id ? row.id.toString() : "";
      case "key":
        return row.key;
      case "pageNumber":
        const pageNumber = this.commonComponents.getPageNumber(row.pageKey);
        return pageNumber === 0 ? "削除済" : pageNumber.toString();
      default:
        return "";
    }
  }

  private updateTargets(targets: ILinkedPageObjectSpecifiable[]) {
    this.commonComponents.updateAllPagesFormatObjects(
      (s, k) => instanceOfIItemSelectTriggerBehaviorPropertyEditable(s) && s.itemSelectTriggerBehavior().isEditable(),
      (s, k) => {
        if (instanceOfIItemSelectTriggerBehaviorPropertyEditable(s) && s.itemSelectTriggerBehavior().isEditable()) {
          const ts = s.itemSelectTriggerBehavior().getValue().targets.concat()
            .filter(v => !this.compareLinkedPageObjectSpecifiable(v, this.currentLinkedObjectIdentifier));
          Enumerable.from(targets)
            .where(t => this.compareLinkedPageObjectSpecifiable(t, this.toLinkedPageObjectSpecifiable(s, k)))
            .forEach(t => ts.splice(ts.length, 0, this.currentLinkedObjectIdentifier));
          s.itemSelectTriggerBehavior().setValue({
            targets: ts,
          });
        }
      });
  }
}
